module.exports = __webpack_public_path__ + "static/media/ic-2.700bd349.svg";